// import {
//   Link,
//   Paper,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// import documentsData from "../data/mandatoryDis/Documents.json";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { baseurl } from "../config";

// type Props = {};

// const MandatoryDisclosure = (props: Props) => {
//   return (
//     <Stack direction="column" spacing={2}>
//       <Stack direction="column" spacing={2} width="100%">
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell
//                   align="center"
//                   sx={{
//                     fontWeight: "bold",
//                     borderBottom: "1px solid black",
//                     fontFamily: "inherit",
//                   }}
//                 >
//                   Sr. No.
//                 </TableCell>
//                 {documentsData?.headings?.map(
//                   (headers: string, index: number) => (
//                     <TableCell
//                       align={index % 2 === 0 ? "left" : "center"}
//                       key={index}
//                       sx={{
//                         fontWeight: "bold",
//                         borderBottom: "1px solid black",
//                         fontFamily: "inherit",
//                       }}
//                     >
//                       {headers}
//                     </TableCell>
//                   )
//                 )}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {documentsData?.data?.map((values: string[], index: number) => (
//                 <TableRow key={index}>
//                   <TableCell
//                     align="center"
//                     sx={{
//                       borderBottom: "1px solid black",
//                       fontFamily: "inherit",
//                     }}
//                   >
//                     {index + 1}
//                   </TableCell>
//                   {values?.map?.((data: string, rowIndex: number) => (
//                     <>
//                       {data?.includes("assets") ? (
//                         <TableCell
//                           align="center"
//                           key={rowIndex}
//                           sx={{
//                             borderBottom: "1px solid black",
//                             fontFamily: "inherit",
//                           }}
//                         >
//                           <Link
//                             href={`${baseurl}${data}`}
//                             target="_blank"
//                             underline="hover"
//                           >
//                             <PictureAsPdfIcon />
//                           </Link>
//                         </TableCell>
//                       ) : (
//                         <TableCell
//                           align="left"
//                           key={rowIndex}
//                           sx={{
//                             borderBottom: "1px solid black",
//                             fontFamily: "inherit",
//                           }}
//                         >
//                           {data}
//                         </TableCell>
//                       )}
//                     </>
//                   ))}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Stack>
//     </Stack>
//   );
// };

// export default MandatoryDisclosure;












import React from "react";
import {
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import documentsData from "../data/mandatoryDis/Documents.json";
import resultAndAcademicData from "../data/mandatoryDis/ResultAndAcademics.json";
import { baseurl } from "../config";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

// ---------- Types ----------
interface TableSection {
  title: string;
  headings: string[];
  data: string[][];
}

// ---------- Example: Multiple Tables ----------
const tableSections: TableSection[] = [
  {
    title: "GENERAL INFORMATION",
    headings: ["SR. NO", "INFORMATION", "DETAILS"],
    data: [
      ["1", "COPY OF SELF-AFFIDAVIT PDF TO UPLOAD", "assets/pdfs/mandatory_disclosure/documents/SELF AFFIDAVIT.pdf"],
      ["2", "NAME OF THE SCHOOL", "ST. XAVIER’S SCHOOL"],
      ["3", "AFFILIATION NUMBER", "1131476"],
      ["4", "SCHOOL CODE", "31465"],
      ["5", "UDISE NO", "27251600913"],
      [
        "6",
        "COMPLETE ADDRESS WITH PIN CODE",
        "Survey no. 39, Shankar Sheth Road, near St. Joseph's Technical, Vrindavan Society, Gultekadi, Pune – 411037, Maharashtra"
      ],
      [
        "7",
        "DIRECTOR AND SCHOOL MANAGER IN CHARGE NAME AND",
        `Fr. Dr. Kenneth Misquitta SJ\nM.A. IN ENGLISH, M.Ed. P.H.D in Educational Administration and Supervision (Chicago USA)`
      ], ["8", "SCHOOL MANAGER EMAIL ID", "kenmisquitta@gmail.com"],
      [
        "9",
        "PRINCIPAL IN CHARGE NAME AND QUALIFICATION",
        "Mr. Thaddeus Kohli, M.A. B.Ed."
      ],
      ["10", "PRINCIPAL EMAIL ID ", "principalstxavierspune@gmail.com"],
      ["11", "SCHOOL EMAIL ID", "stxavierspune37@gmail.com"],
      [
        "12",
        "CONTACT DETAILS (LANDLINE/MOBILE)",
        "020-29972597 / 8149830102"
      ]
    ]
  },

  {
    title: "DOCUMENTS & INFORMATION",
    headings: documentsData.headings,
    data: documentsData.data,
  },
  {
    title: "RESULTS & ACADEMICS",
    headings: resultAndAcademicData.headings,
    data: resultAndAcademicData.data,
  },
  {
    title: "STAFF INFORMATION",
    headings: ["SR. NO", "INFORMATION", "DETAILS"],
    data: [
      ["1", "Staff Details", "https://stxavierspune.edu.in/administration/staff-details"],
    ]
  },
  {
    title: "SCHOOL INFRASTRUCTURE",
    headings: ["SR. NO", "INFORMATION", "Area (In Sq. Mtr)", "Numbers", "DETAILS"],
    data: [
      ["1", "Total Area", "25765.28 SQ.M", "__ROWSPAN_2__1", "__ROWSPAN_2__Single Plot of Land"],
      ["2", "Total campus area of the school (in square mtr) ", "12354.89 SQ.M", "__SKIP__", "__SKIP__"],
      ["3", "Built Up Area", "3931.22 SQ. M", "Block (1)", "G + 2 Floors"],
      ["4", "Total number of Playground in school (Greater Than or Equal To 10000 Sq. Ft)", "59115 SQ. M", "02 Grounds", "Part Of School Plot"],
      ["5", "Total Number of Sites of School", "N/A", "01", "N/A"],
      ["6", "Class Rooms", "46.45 SQ.M", "26", "Well- Furnished and CCTV Enabled."],
      ["7", "Composite Science Lab", "55.74 SQ.M", "1", "Having All Apparatus as Per CBSE Sops"],
      ["8", "Computer Lab", "55.74 SQ.M", "1", "Having 40 Computers and Internet Connection"],
      ["9", "Mathematics Lab", "46.45 SQ.M", "1", "Having All Apparatus as Per CBSE Sops"],
      ["10", "Library", "111.48 SQ.M", "1", "With More Than 1500+ Books And 1 Computer"],
      ["11", "Sports Room", "46.45 SQ.M", "1", "Having All Apparatus as Per CBSE Sops"],
      ["12", "Music Room And Art Room", "55.74 SQ.M", "1", "Having All Apparatus as Per CBSE Sops"],
      ["13", "Admin Office", "33.5685 SQ.M", "1", "For Day-To-Day Operation"],
      ["14", "Principal Office", "33.5685 SQ.M", "1", "For Day-To-Day Operation"],
      ["15", "Internet Facility (Y/N)", "YES", "N/A", "N/A"],
      ["16", "Total Number of Toilets", "665.25 SQ.M ", "26", "Seats Including CWSN Friendly Toilets for Boys"],
      ["17", "Total Number of Toilets", "665.25 SQ.M ", "16", "Seats Including CWSN Friendly Toilets for Girls"],
      ["18", "Total Number of Urinals", "N/A", "45", "Only for Boys"],
      ["19", "No. Of CWSN Toilet ", "6.3 SQ.M ", "03", "Seats Including CWSN Friendly Toilet"],


      // ["8", "No. and size of the classrooms in sq. mts.", "26 & 48.412 sq. m."],
      // ["9", "No and size of laboratories including computer labs in square mtr", "04 & 60"],
      // ["10", "Internet facility (Y/N)", "Yes"],
      // ["11", "Total number of toilet seats including CWSN friendly toilets for boys", "26"],
      // ["12", "Total number of toilet seats including CWSN friendly toilets for boys", "16"],
      // ["13", "Total Number of urinals for boys", "45"],
      // ["14", "No. of CWSN toilet", "03"],
    ]
  },
];

// ---------- Reusable Table Component ----------
// const DynamicTable: React.FC<{
//   headings: string[];
//   data: string[][];
// }> = ({ headings, data }) => {
//   return (
//     <TableContainer
//       component={Paper}
//       sx={{
//         border: "1px solid black",
//         borderRadius: 1,
//       }}
//     >
//       <Table>
//         <TableHead>
//           <TableRow>
//             {headings.map((header, index) => (
//               <TableCell
//                 key={index}
//                 align={"center"}
//                 sx={{
//                   fontWeight: "bold",
//                   border: "1px solid black",
//                 }}
//               >
//                 {header}
//               </TableCell>
//             ))}
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {data.map((row, rowIndex) => (
//             <TableRow key={rowIndex}>
//               {row.map((cell, cellIndex) =>
//                 cell?.includes("assets") ? (
//                   // PDF link
//                   <TableCell
//                     key={cellIndex}
//                     align="center"
//                     sx={{ border: "1px solid black", whiteSpace: "pre-line", }}
//                   >
//                     <Link
//                       href={`${baseurl}${cell}`}
//                       target="_blank"
//                       underline="hover"
//                     >
//                       <PictureAsPdfIcon color="error" />
//                     </Link>
//                   </TableCell>
//                 ) : cell?.startsWith("http") ? (
//                   // External URL link (like "See Details")
//                   <TableCell
//                     key={cellIndex}
//                     align="center"
//                     sx={{ border: "1px solid black", whiteSpace: "pre-line" }}
//                   >
//                     <Link
//                       href={cell}
//                       target="_blank"
//                       underline="hover"
//                       sx={{ color: "Blue", textDecoration: "underline" }}
//                     >
//                       See Details
//                     </Link>
//                   </TableCell>
//                 ) : (
//                   // Normal text
//                   <TableCell
//                     key={cellIndex}
//                     align="center"
//                     sx={{ border: "1px solid black", whiteSpace: "pre-line" }}
//                   >
//                     {cell}
//                   </TableCell>
//                 )

//               )}
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

const DynamicTable: React.FC<{
  headings: string[];
  data: string[][];
}> = ({ headings, data }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ border: "1px solid black", borderRadius: 1 }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {headings.map((header, index) => (
              <TableCell
                key={index}
                align="center"
                sx={{ fontWeight: "bold", border: "1px solid black" }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => {
                // Skip cells that are consumed by a rowspan above
                if (cell === "__SKIP__") return null;

                // Check for rowspan marker
                const isRowSpan = cell?.startsWith("__ROWSPAN_2__");
                const actualValue = isRowSpan
                  ? cell.replace("__ROWSPAN_2__", "")
                  : cell;
                const rowSpanProps = isRowSpan ? { rowSpan: 2 } : {};

                return actualValue?.includes("assets") ? (
                  <TableCell
                    key={cellIndex}
                    align="center"
                    sx={{ border: "1px solid black", whiteSpace: "pre-line" }}
                    {...rowSpanProps}
                  >
                    <Link href={`${baseurl}${actualValue}`} target="_blank" underline="hover">
                      <PictureAsPdfIcon color="error" />
                    </Link>
                  </TableCell>
                ) : actualValue?.startsWith("http") ? (
                  <TableCell
                    key={cellIndex}
                    align="center"
                    sx={{ border: "1px solid black" }}
                    {...rowSpanProps}
                  >
                    <Link href={actualValue} target="_blank" underline="hover" sx={{ color: "Blue", textDecoration: "underline" }}>
                      See Details
                    </Link>
                  </TableCell>
                ) : (
                  <TableCell
                    key={cellIndex}
                    align="center"
                    sx={{ border: "1px solid black", whiteSpace: "pre-line" }}
                    {...rowSpanProps}
                  >
                    {actualValue}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// ---------- Main Page ----------
const MandatoryDisclosure: React.FC = () => {
  return (
    <Stack direction="column" spacing={4}>
      {tableSections.map((section, index) => (
        <Stack key={index} spacing={2}>
          <Typography variant="h6" fontWeight="bold">
            {section.title}
          </Typography>
          <DynamicTable headings={section.headings} data={section.data} />
        </Stack>
      ))}
    </Stack>
  );
};

export default MandatoryDisclosure;
